import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { t } from 'ember-intl';

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    PageLoading: typeof PageLoading;
  }
}

const PageLoading: TemplateOnlyComponent = <template>
  <div
    class="flex h-full min-h-screen items-center justify-center"
    role="status"
    aria-live="polite"
    data-test-page-loading
  >
    <sl-spinner class="loading-spinner-lg"></sl-spinner>
    <span class="sr-only">{{t "Loading"}}</span>
  </div>
</template>;

export default PageLoading;
